import React, { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { viewerActions } from "./store/viewer";
import { selectors as viewerSelectors } from "./store/viewer";
import MIC from "./config/mic";
import HOTDOG from "./config/hotdog";
import TRUCK from "./config/truck";
import DRUM from "./config/drum";
import AppStyle from "./style";
import Header from "./views/header";
import Footer from "./views/footer";

import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Viewer from "./views/viewer";

import drumImg from "./assets/thumbnails/drum.png";
import hotdogImg from "./assets/thumbnails/hotdog.png";
import micImg from "./assets/thumbnails/mic.png";
import truckImg from "./assets/thumbnails/truck.png";

const imageList = [
  { id: 0, params: MIC, src: micImg },
  { id: 1, params: HOTDOG, src: hotdogImg },
  { id: 2, params: TRUCK, src: truckImg },
  { id: 3, params: DRUM, src: drumImg },
];

function App({
  objFiles,
  pngFiles,
  jsonFile,
  params,
  initParams,
  addFiles,
  handleChange,
}) {
  const [activeIndex, selectActiveIndex] = useState(0);
  useEffect(() => {
    addFiles(imageList[activeIndex].params);
  }, [activeIndex]);
  if (!objFiles || !pngFiles || !jsonFile) {
    return <div>Loading...</div>;
  }
  return (
    <AppStyle>
      <Header />
      <div className="content">
        <div className="side-content">
          {imageList.map((image) => (
            <Fragment key={image.id}>
              <div
                onClick={() => {
                  if (activeIndex !== image.id) {
                    initParams();
                    selectActiveIndex(image.id);
                  }
                }}
                className={
                  activeIndex === image.id
                    ? "my-2 side-body-content side-body-content-active"
                    : "my-2 side-body-content"
                }
              >
                <div className="side-body-content-image-card">
                  <div className="side-body-content-image">
                    <img src={image.src} />
                  </div>
                </div>
              </div>
            </Fragment>
          ))}
        </div>
        <div className="main-content">
          <div className="canvas">
            <Viewer />
          </div>
          <div className="controls">
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  control={
                    <Switch
                      name="feature"
                      onChange={handleChange}
                      checked={params.feature}
                      color="primary"
                    />
                  }
                  label="Feature Image"
                  labelPlacement="start"
                />
                <FormControlLabel
                  control={
                    <Switch
                      name="output"
                      onChange={handleChange}
                      checked={params.output}
                      color="primary"
                    />
                  }
                  label="Final Output"
                  labelPlacement="start"
                />
              </FormGroup>
            </FormControl>
          </div>
        </div>
      </div>

      <Footer />
    </AppStyle>
  );
}

const mapStateToProps = (state) => ({
  objFiles: viewerSelectors.objFiles(state),
  pngFiles: viewerSelectors.pngFiles(state),
  jsonFile: viewerSelectors.jsonFile(state),
  params: viewerSelectors.params(state),
});

const mapDispatchToProps = {
  initParams: viewerActions.initParams,
  addFiles: viewerActions.addFiles,
  handleChange: viewerActions.handleChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
